export default "__VITE_ASSET__YZOFA0tp__"